import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  SimpleSnackBar,
} from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) {}

  open(
    message: string | { key: string; param?: any },
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<SimpleSnackBar> {
    let translatedMessage;

    if (typeof message === 'string') {
      translatedMessage = this.translateService.instant(message);
    } else {
      translatedMessage = this.translateService.instant(
        message.key,
        message.param
      );
    }

    return this.snackBar.open(
      translatedMessage,
      action && this.translateService.instant(action),
      config
    );
  }

  openMessage(
    message: string | { key: string; param?: any },
    duration: number = 2500
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.open(message, null, { duration });
  }

  openConfirm(
    message: string | { key: string; param?: any }
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.open(message, 'common.actions.close');
  }

  openGenealErrorMessage(
    code?: number | string,
    duration: number = 2500
  ): MatSnackBarRef<SimpleSnackBar> {
    let message;

    if (code != null) {
      message = {
        key: 'common.messages.generalErrorWithCode',
        param: { code },
      };
    } else {
      message = 'common.messages.generalError';
    }

    return this.openMessage(message, duration);
  }
}
